/**
 * Floating banner: hides while the page is actively scrolling (SP only,
 * viewport <= 768px) and reappears once scrolling stops.
 */
const floatingbnr = (): void => {
  const banner = document.querySelector<HTMLElement>('.js-floating');
  if (!banner) return;

  let scrollTimer = 0;

  window.addEventListener(
    'scroll',
    () => {
      // if (window.innerWidth > 768) {
      //   banner.classList.remove('is-hidden');
      //   return;
      // }

      banner.classList.add('is-hidden');

      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        banner.classList.remove('is-hidden');
      }, 5000);
    },
    { passive: true },
  );
};

export default floatingbnr;
